import React from "react";
import { Card, CardBody, CardHeader } from "@heroui/react";
import { useTranslation } from "react-i18next";

import { VERSION_INFO } from "@/types/version";

export const AboutSettings: React.FC = () => {
  const { t } = useTranslation();

  const formattedBuildDate = new Date(VERSION_INFO.buildDate).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <Card>
      <CardHeader>
        <h2 className="text-xl font-semibold flex items-center gap-2">
          <span>{t("About")}</span>
        </h2>
      </CardHeader>
      <CardBody className="space-y-2">
        <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
          <p>
            <span className="font-medium">{t("Version")}:</span> v{VERSION_INFO.version}
            {VERSION_INFO.commit !== "development" && (
              <span className="ml-1">({VERSION_INFO.commit})</span>
            )}
          </p>
          <p>
            <span className="font-medium">{t("Branch")}:</span> {VERSION_INFO.branch}
          </p>
          <p>
            <span className="font-medium">{t("Built")}:</span> {formattedBuildDate}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};
